import {useCallback} from "react";
import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import {PaymentCardInput, PaymentCardResult} from "../types/PaymentCard";
import useCacheRemove from "../../core/services/query/hooks/useCacheRemove";
import {PAYMENT_CARDS_CACHE_KEY} from "./usePaymentCardsGet";

export default function usePaymentCardSave(): (input: PaymentCardInput) => Promise<PaymentCardResult> {
    const client = useAPIClient(undefined, false);
    const removeCache = useCacheRemove();

    return useCallback((input: PaymentCardInput) => {
        return client.post<PaymentCardResult>("payment_cards", input).then(result => {
            removeCache([PAYMENT_CARDS_CACHE_KEY]);
            return result;
        });
    }, [client, removeCache]);
}
